// extracted by mini-css-extract-plugin
module.exports = {"exerciseBox4":"L4_exerciseBox4__MpaI5","explanation":"L4_explanation__2is1P","correctUnderline":"L4_correctUnderline__1l0UC"};